import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { BoardFeatureResponse } from '../../common/types.tsx';
import { getBoardFeaturesUrl } from '../utils.tsx';

export const getBoardFeatures = async (boardId: number) => {
	const data = await performGetRequest<BoardFeatureResponse>(getBoardFeaturesUrl(boardId));
	return data.features;
};
